/*
 * Public API Surface of ai
 */

export * from './lib/ai.routes';
export * from './lib/components/ai-chat/ai-chat.component';
export * from './lib/interfaces/ai-documentation-categories';
export * from './lib/interfaces/documentation-origin';
export * from './lib/interfaces/mcp-tools';
export * from './lib/interfaces/origin-file-information';
export * from './lib/pipes/markdown-with-color.pipe';
export * from './lib/services/ai-chat.service';
export * from './lib/services/ai-file-preview.provider';

// Backward-compatible re-exports from @sia/file-system
// I consumatori esistenti che importano da @sia/ai continueranno a funzionare
export * from './lib/components/ai-file-preview-email/ai-file-preview-email.component';
export * from './lib/components/ai-file-preview/ai-file-preview.component';
export * from './lib/components/ai-file-preview-excel/ai-file-preview-excel.component';
export * from './lib/components/ai-preview-handler/ai-preview-handler.component';
